var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"demo"}},[_c('div',{staticStyle:{"display":"block"}},[_c('Login',{attrs:{"loginSuccess":_vm.loginSuccess},on:{"handleLogin":_vm.handleLogin}}),_c('PhoneBar',{attrs:{"loginSuccess":_vm.loginSuccess,"loginInfo":_vm.loginInfo},on:{"handleLogin":_vm.handleLogin}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }